export default "__VITE_ASSET__585f7a23__"